import React from "react";
import { doGetBroadcastListCustomerPage } from "stores/slices/broadcastList";

import AppTable from "components/table";
const OptInOrOutTable = props => {
  const { searchParam, setSearchParam, columns, isRefreshTable } = props;

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    let newParams = {};
    switch (dataIndex) {
      case "name":
        newParams = {
          ...searchParam,
          searchKeyName: selectedKeys[0]
            ? selectedKeys[0].trim()
            : selectedKeys[0],
        };
        break;
    }
    newParams = { ...newParams, pageNumber: 1 };
    setSearchParam({ ...newParams, pageNumber: 1 });
  };

  return (
    <>
      <AppTable
        api={doGetBroadcastListCustomerPage(searchParam)}
        handleSearch={handleSearch}
        columns={columns}
        searchParam={searchParam}
        isRefresh={isRefreshTable}
        scroll="auto"
      />
    </>
  );
};

export default OptInOrOutTable;
